// Phase 1C — compute which of the four fixed 500x500 world tiles intersect a
// visible world rectangle. Pure; called both by GridViewer and by tests.
import type { TileCoord } from "./tiles";

export const WORLD_SIZE = 1000;

export interface WorldRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** True iff integer world cell (ix, iy) is inside [0, WORLD_SIZE). */
export function isInsideWorld(ix: number, iy: number, size: number = WORLD_SIZE): boolean {
  return Number.isInteger(ix) && Number.isInteger(iy) && ix >= 0 && iy >= 0 && ix < size && iy < size;
}

/**
 * Return the subset of {(0,0),(1,0),(0,1),(1,1)} whose 500x500 world extent
 * intersects the given world-space rect. Uses half-open [x, x+w) semantics.
 */
export function visibleTiles(view: WorldRect): TileCoord[] {
  const out: TileCoord[] = [];
  for (const ty of [0, 1] as const) {
    for (const tx of [0, 1] as const) {
      const tx0 = tx * 500;
      const ty0 = ty * 500;
      const tx1 = tx0 + 500;
      const ty1 = ty0 + 500;
      if (view.x + view.w <= tx0) continue;
      if (view.x >= tx1) continue;
      if (view.y + view.h <= ty0) continue;
      if (view.y >= ty1) continue;
      out.push({ tileX: tx, tileY: ty });
    }
  }
  return out;
}
